import { render, staticRenderFns } from "./ThaiPhoneNumber.vue?vue&type=template&id=1f55d597&scoped=true&"
import script from "./ThaiPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./ThaiPhoneNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f55d597",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
